<template lang="html">
  <div class="job">
    <h3>{{ position }} {{ at }} <a target="_blank" :href="link">{{ employer }}</a></h3>
    <h4>{{ start }} - {{ end }}</h4>
    <p v-html="text"></p>
    <br />
    <p v-if="keywords"><strong>{{keywords.label}}</strong>: {{keywords.value}}</p>
  </div>
</template>


<script>
export default {
  name: 'Job',
  props: ['position', 'at', 'employer', 'text', 'link', 'start', 'end', 'keywords'],
};
</script>

<style lang="scss" scoped>
.job {
  h4 {
    font-family: $ff;
    font-size: ms(-1);
    color: $mid;
    margin-top: ms(-2);
    margin-bottom: ms(1);
  }

  p a {
    text-decoration: none;
    border-bottom: none;
  }
}
</style>
